import { createSelector } from "@ngrx/store";

import { IAppState } from "../state/app.state";
import { ILanguageState } from "@edp-store/state/language.state";

const languageSelector = (state: IAppState) => state.languages;


export const getLanguages = createSelector(
    languageSelector,
    (state: ILanguageState) => state.languages
);
